import { render, staticRenderFns } from "./image.vue?vue&type=template&id=e40501d0&scoped=true"
import script from "./image.vue?vue&type=script&lang=js"
export * from "./image.vue?vue&type=script&lang=js"
import style0 from "./image.vue?vue&type=style&index=0&id=e40501d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40501d0",
  null
  
)

export default component.exports